import { render, staticRenderFns } from "./associated.vue?vue&type=template&id=72951c0e"
import script from "./associated.vue?vue&type=script&lang=js"
export * from "./associated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports